import { createSlice } from '@reduxjs/toolkit';
import { createAsyncAction } from '../action/index';

const getAggregateDoctors = createAsyncAction('getAggregateDoctors', 'getAggregateDoctors');
const getClinics = createAsyncAction('getClinics', 'getClinics');
const getVcPrice = createAsyncAction('getVcPrice', 'getVcPrice');
const getDoctorDetails = createAsyncAction('getDoctorDetails', 'getDoctorDetails');
const searchDoctor = createAsyncAction('searchDoctor', 'searchDoctor');
const getClinicDetails = createAsyncAction('getClinicDetails', 'getClinicDetails');
const getUserPatients = createAsyncAction('getUserPatients', 'getUserPatients');

interface InitialState {
  doctorsByUserId: any;
  clinicsByDocId: any;
  clinicByClinicId: any;
  doctorsByShortUrl: any;
  vcPriceByDocId: any;
  searchedDoctors: any[];
  doctorSearchText: string;
  patientsByClinicID: any,
  isFetchingDoctors: boolean;
  isFetchingClinics: boolean;
  isFetchingVcPrice: boolean;
  isFetchingDoctor: boolean;
  isFetchingSearchDoctor: boolean;
  isFetchingClinicDetails: boolean,
  isFetchingPatients: boolean,
}

const initialState = {
  doctorsByUserId: {},
  clinicsByDocId: {},
  clinicByClinicId: {},
  doctorsByShortUrl: {},
  vcPriceByDocId: {},
  searchedDoctors: [],
  doctorSearchText: '',
  patientsByClinicID: {},
  isFetchingDoctors: true,
  isFetchingClinics: true,
  isFetchingVcPrice: true,
  isFetchingDoctor: true,
  isFetchingSearchDoctor: false,
  isFetchingClinicDetails: false,
  isFetchingPatients: false,
} as InitialState;

export const counterSlice = createSlice({
  name: 'doctor',
  initialState,
  reducers: {
    updateDoctorState: (state, action) => Object.assign(state, action.payload),
  },
  extraReducers: {
    [getAggregateDoctors.pending as any]: (state) => {
      state.isFetchingDoctors = true;
    },
    [getAggregateDoctors.fulfilled as any]: (state, { payload, meta }) => {
      const userID = meta.arg.userID;
      state.doctorsByUserId[userID] = payload?.user?.doctorDetails || payload?.user?.doctorDetails?.user || [];
      state.isFetchingDoctors = false;
    },
    [getAggregateDoctors.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingDoctors = false;
    },
    [getClinics.pending as any]: (state) => {
      state.isFetchingClinics = true;
    },
    [getClinics.fulfilled as any]: (state, { payload, meta }) => {
      const doctorID = meta.arg;
      state.clinicsByDocId[doctorID] = payload || [];
      (payload || []).forEach(clinic => {
        state.clinicByClinicId[clinic.clinicID] = clinic;
      });
      state.isFetchingClinics = false;
    },
    [getClinics.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingClinics = false;
    },
    [getVcPrice.pending as any]: (state) => {
      state.isFetchingVcPrice = true;
    },
    [getVcPrice.fulfilled as any]: (state, { payload, meta }) => {
      const doctorID = meta.arg;
      state.vcPriceByDocId[doctorID] = payload || [];
      state.isFetchingVcPrice = false;
    },
    [getVcPrice.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingVcPrice = false;
    },
    [getDoctorDetails.pending as any]: (state) => {
      state.isFetchingDoctor = true;
    },
    [getDoctorDetails.fulfilled as any]: (state, { payload, meta }) => {
      const shortUrl = meta.arg;
      state.doctorsByShortUrl[shortUrl] = payload || {};
      state.isFetchingDoctor = false;
    },
    [getDoctorDetails.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingDoctor = false;
    },
    [searchDoctor.pending as any]: (state, { meta }) => {
      state.isFetchingSearchDoctor = true;
      state.searchedDoctors = [];
      state.doctorSearchText = meta.arg;
    },
    [searchDoctor.fulfilled as any]: (state, { payload }) => {
      const searchedDoctors = payload?.data || [];
      state.searchedDoctors = searchedDoctors;
      state.isFetchingSearchDoctor = false;
    },
    [searchDoctor.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingSearchDoctor = false;
    },
    [getClinicDetails.pending as any]: (state) => {
      state.isFetchingClinicDetails = true;
    },
    [getClinicDetails.fulfilled as any]: (state, { payload, meta }) => {
      const clinicID = meta.arg;
      state.isFetchingClinicDetails = false;
      state.clinicByClinicId[clinicID] = payload || {};
    },
    [getClinicDetails.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingClinicDetails = false;
    },
    [getUserPatients.pending as any]: (state) => {
      state.isFetchingPatients = true;
    },
    [getUserPatients.fulfilled as any]: (state, { payload, meta }) => {
      const clinicID = meta.arg.clinicID;
      state.patientsByClinicID[clinicID] = payload?.patients || [];
      state.isFetchingPatients = false;
    },
    [getUserPatients.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingPatients = false;
    },
  },
});

// Action creators are generated for each case reducer function
const { updateDoctorState } = counterSlice.actions;
export {
  getAggregateDoctors,
  getClinics,
  getVcPrice,
  getDoctorDetails,
  searchDoctor,
  updateDoctorState,
  getClinicDetails,
  getUserPatients,
};
export default counterSlice.reducer;